export const DEFAULT_EASE = [0.4, 0, 0, 1];
export const DEFAULT_DURATION_S = 1;
